import { render, staticRenderFns } from "./FormDefinitionList.vue?vue&type=template&id=23b4114a"
import script from "./FormDefinitionList.vue?vue&type=script&lang=js"
export * from "./FormDefinitionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b4114a')) {
      api.createRecord('23b4114a', component.options)
    } else {
      api.reload('23b4114a', component.options)
    }
    module.hot.accept("./FormDefinitionList.vue?vue&type=template&id=23b4114a", function () {
      api.rerender('23b4114a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/FormDefinitionList.vue"
export default component.exports